  <!-- TODO: возможно есть смысл вынести общее оформление (section) в родительский модуль -->
<div class="p-d-flex p-flex-column section real-property-list" *ngIf="list.length">
  <div class="p-d-flex p-flex-row p-ai-center p-jc-start p-jc-md-between header">
        <span class="p-d-flex p-flex-row p-ai-center title">
          <div class="circle p-d-md-flex p-d-none accent">•</div>
          Мои объекты
        </span>
    <div class="p-d-flex p-flex-row p-ai-center total-count">
      <span>
        {{total}}
      </span>
    </div>
  </div>
  <div class="body">
    <ng-container *ngIf="list.length">
      <div class="p-d-flex p-flex-row p-jc-between list"
           infinite-scroll
           [infiniteScrollDistance]="3"
           [immediateCheck]="true"
           (scrolled)="onScrollDown()">
        <app-real-property-basic-info
          *ngFor="let application of list"
          [application]="application">
        </app-real-property-basic-info>
      </div>
    </ng-container>
    <ng-container *ngIf="list.length === 0">
      <div class="no-data">
        Нет объектов
      </div>
    </ng-container>
  </div>
</div>
<ng-container *ngIf="loading">
  <app-ns-spinner></app-ns-spinner>
</ng-container>
